<template>
  <div :class="['card h-100 d-flex flex-column',
  { ' p-3': !noPadding }]">
    <h5 :class="['card__title d-flex justify-content-between align-items-start flex-grow-0',
    { 'p-3': noPadding}]">
      <div class="flex-grow-0 d-flex align-items-center">
        <span class="icon"><slot name="icon" /></span>
      </div>

      <div class="text-left flex-grow-1 mx-2 d-flex align-items-center">
        <slot name="title" />
      </div>

      <div v-if="$slots.controls" class="card__controls flex-grow-0 d-flex align-items-center">
        <div class="position-relative" ref="controls">
          <span
            ref="showControlsButton"
            @click="openControls"
            class="btn btn-transparent btn-circle pointer"
            :class="{ 'is-active' : showControls }"
            >
            <img src="@/assets/images/icon_tools.svg" alt="Personalizar">
          </span>

          <div v-show="showControls" class="card__controls__panel px-5 py-4">
            <slot name="controls" />
          </div>
        </div>
      </div>
    </h5>

    <div class="card__content flex-grow-1 d-flex flex-column justify-content-around">
      <slot />
    </div>
  </div>
</template>

<script>
import DOMUtils from '@/utils/DOMUtils';

export default {
  name: 'DashboardCard',
  props: {
    noPadding: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showControls: false,
    };
  },
  methods: {
    closeControls() {
      this.showControls = false;
      document.removeEventListener('click', this.handleClose);
    },
    handleClose(event) {
      const hasDay = event.target.className.indexOf('day') > -1;
      if (!DOMUtils.isChildOf(event.target, this.$refs.controls) && !hasDay) this.closeControls();
    },
    toggleControls() {
      if (this.showControls) {
        this.closeControls();
      } else {
        this.showControls = true;
        document.addEventListener('click', this.handleClose);
      }
    },
    openControls() {
      this.toggleControls();
      if (this.showControls) {
        this.$emit('controlsOpen');
      } else {
        this.$emit('constrolsClose');
      }
    },
  },
  provide() {
    return {
      toggleControls: this.toggleControls,
    };
  },
};
</script>

<style lang="scss" scoped>
.card {
  @include border-light();
  @include rounded-big();
  @include text-size-regular();
}

.card__title {
  @include text-size-big();
  color: $grey-2;
}

.card__controls__panel {
  position: absolute;
  right: 50%;
  top: 100%;
  background: $bg-default;
  min-width: 215px;
  max-width: 70vw;
  z-index: 2;
  @include box-shadow();
  @include text-size-regular();
}

.icon, .card-icon {
  max-width: 22px;
}
</style>
